import {
	hideLoadingScreen,
	router,
	setPageContent,
	showLoadingScreen,
} from "..";
import { getSp2, putSp2 } from "../api/smartplug2s_{imei}";
import { locale } from "../locale";
import { onMobile, scanBarcode } from "../mobile";
import { state } from "../state";
import { Bulma } from "../view/bulma";
import { centeredBox, errorToast, successToast } from "../view/components";
import { MaterialDesign } from "../view/material_design";

/**
 * @type {import("navigo").Handler}
 */
function registerSmartplug2Page(ctx) {
	const imei = Bulma.input({
		type: "text",
	});

	const name = Bulma.input({
		type: "text",
	});

	setPageContent(
		centeredBox(
			"small",
			Bulma.level(
				Bulma.levelLeft(
					Bulma.levelItem(
						Bulma.title(
							locale.string({
								enGB: "Register SmartPlug2",
								deDE: "Registrieren SmartPlug2",
								frFR: "Enregistrez SmartPlug2",
								svSE: "Registrera SmartPlug2",
							}),
							"is-4",
						),
					),
				),
				Bulma.levelRight(
					Bulma.levelItem(
						MaterialDesign.icon({
							id: "help",
							onClick: () =>
								window.open(
									locale.string({
										enGB: "https://support.luda.farm/en/support/solutions/folders/14000131500",
										deDE: "https://support.luda.farm/de/support/solutions/folders/14000131500",
										frFR: "https://support.luda.farm/fr/support/solutions/folders/14000131500",
										svSE: "https://support.luda.farm/sv-SE/support/solutions/folders/14000131500",
									}),
									"_blank",
								),
						}),
					),
				),
			),
			Bulma.field(
				{},
				Bulma.label("IMEI"),
				Bulma.field(
					{
						styles: onMobile ? ["has-addons"] : undefined,
					},
					Bulma.control(
						{
							styles: ["is-expanded"],
						},
						imei.element,
					),
					Bulma.control(
						{
							hidden: !onMobile,
						},
						Bulma.button(
							{
								onClick: onClickScan,
							},
							MaterialDesign.icon({
								id: "barcode",
								alignment: "right",
							}),
						),
					),
				),
			),
			Bulma.field(
				{},
				Bulma.label(
					locale.string({
						enGB: "Choose a name for your device",
						deDE: "Wählen Sie einen Namen für Ihr Gerät",
						frFR: "Choisissez un nom pour votre appareil",
						svSE: "Välj ett namn för din enhet",
					}),
				),
				Bulma.control({}, name.element),
			),
			Bulma.field(
				{
					styles: ["is-grouped"],
				},
				Bulma.control(
					{},
					Bulma.button(
						{
							onClick: onClickRegister,
							styles: ["is-primary"],
						},
						locale.strings.register,
					),
				),
				Bulma.control(
					{},
					Bulma.button(
						{
							onClick: () => router.jump("/devices/register"),
							styles: ["is-primary"],
						},
						locale.strings.back,
					),
				),
			),
		),
	);

	async function onClickRegister() {
		showLoadingScreen();
		try {
			const user = await state.getActiveUser();

			let sp2 = await getSp2(imei.getValue());
			sp2.Metadata.Access = [user.Email];
			sp2.Metadata.Name = name.getValue();
			sp2.Metadata.OwnerEmail = user.Email;

			sp2 = await putSp2(sp2);
			state.smartplug2s[sp2.Imei] = sp2;
			router.jump(`/smartplug2/${sp2.Imei}`);

			successToast();
		} catch (e) {
			errorToast(e);
		} finally {
			hideLoadingScreen();
		}
	}

	async function onClickScan() {
		scanBarcode(
			locale.string({
				enGB: "Scan the IMEI barcode. If the barcode is not recognized, enter the IMEI manually.",
				deDE: "Scannen Sie den IMEI-Strichcode. Wenn der Barcode nicht erkannt wird, geben Sie die IMEI manuell ein.",
				frFR: "Scannez le code-barres IMEI. Si le code-barres n'est pas reconnu, saisissez l'IMEI manuellement.",
				svSE: "Skanna streckkoden för IMEI. Om streckkoden inte känns igen anger du IMEI manuellt.",
			}),
		).then((code) => {
			if (!code) return;
			imei.setValue(code);
		});
	}
}

export { registerSmartplug2Page };
